import { startCheckout } from '../stripe';

type PlanTier = 'plus' | 'pro';

interface PlanButtonProps {
  tier: PlanTier;
  variant?: 'primary' | 'pill';
  wasPlaying?: boolean;
}

const handleUpgrade = async (tier: PlanTier, wasPlaying?: boolean) => {
  const returnTo = window.location.pathname;
  await startCheckout(tier, returnTo, wasPlaying);
};

export const PlusButton = ({
  variant = 'primary',
  wasPlaying,
}: Omit<PlanButtonProps, 'tier'>) => {
  const handleClick = () => {
    handleUpgrade('plus', wasPlaying);
  };

  if (variant === 'pill') {
    return (
      <button onClick={handleClick} className="pill-button">
        Upgrade to Plus — $5/mo
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      style={{
        borderRadius: '14px',
        cursor: 'pointer',
        fontFamily: "'Roboto', arial, sans-serif",
        fontSize: '14px',
        fontWeight: 600,
        height: '44px',
        padding: '0 14px',
        minWidth: '220px',
        backgroundColor: 'var(--teal)',
        color: 'var(--background)',
        border: 'none',
      }}
    >
      Upgrade to Plus — $5/month
    </button>
  );
};

export const ProButton = ({
  variant = 'primary',
  wasPlaying,
}: Omit<PlanButtonProps, 'tier'>) => {
  const handleClick = () => {
    handleUpgrade('pro', wasPlaying);
  };

  if (variant === 'pill') {
    return (
      <button onClick={handleClick} className="pill-button">
        Upgrade to Pro — $20/mo
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      style={{
        borderRadius: '14px',
        cursor: 'pointer',
        fontFamily: "'Roboto', arial, sans-serif",
        fontSize: '14px',
        fontWeight: 700,
        height: '44px',
        padding: '0 14px',
        minWidth: '220px',
        background:
          'linear-gradient(90deg, rgba(var(--gold-rgb),0.95), rgba(var(--teal-rgb),0.85))',
        color: 'var(--background)',
        border: 'none',
      }}
    >
      Upgrade to Pro — $20/month
    </button>
  );
};
